import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, FileSpreadsheet, FileText, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ANALYTICS_TOOLBAR_BUTTON_COMPACT_CLASS } from "./toolbarButtonStyles";

type AnalyticsExportMenuProps = {
  onExport: (format: "csv" | "xlsx") => void;
  disabled?: boolean;
  formats?: Array<"csv" | "xlsx">;
  label?: string;
  className?: string;
};

export const AnalyticsExportMenu: React.FC<AnalyticsExportMenuProps> = ({
  onExport,
  disabled = false,
  formats = ["xlsx", "csv"],
  label,
  className,
}) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t("analytics.export.label", "Export");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          type="button"
          variant="span"
          className={className ?? ANALYTICS_TOOLBAR_BUTTON_COMPACT_CLASS}
        >
          <Share className="size-3.5 shrink-0" />
          {resolvedLabel}
          <ChevronDown className="size-3.5 shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {formats.includes("xlsx") ? (
          <DropdownMenuItem onClick={() => onExport("xlsx")}>
            <FileSpreadsheet className="size-4" />
            {t("analytics.common.xlsx", "XLSX")}
          </DropdownMenuItem>
        ) : null}
        {formats.includes("csv") ? (
          <DropdownMenuItem onClick={() => onExport("csv")}>
            <FileText className="size-4" />
            {t("analytics.common.csv", "CSV")}
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
